import * as React from 'react';
import { BaSeTooltip } from '@base/react';

export const RelatorioFluxoTooltip = ({ children, message }) => {
  const [open, setOpen] = React.useState(false);

  const cloned = React.useMemo(() => {
    if (React.isValidElement(children)) {
      return React.cloneElement(children, {
        onMouseEnter: () => setOpen(true),
        onMouseLeave: () => setOpen(false),
      });
    }
  }, [children]);

  return (
    <>
      <BaSeTooltip
        color="default"
        delayToOpen={0}
        coordinates={{ top: '-20px', left: '25%' }}
        direction="top"
        message={message}
        messageNoBreakLine
        size="small"
        themeMode="light"
        open={open}
      />
      {cloned}
    </>
  );
};
